/**
 * Filters input to only allow numeric characters (digits and at most one decimal point).
 * A comma is treated as a decimal separator (e.g. "5,5" → "5.5").
 */
export function formatNumericInput(value: string): string {
  const withDecimalDot = value.replace(/,/g, ".");
  const digitsAndDot = withDecimalDot.replace(/[^\d.]/g, "");
  const parts = digitsAndDot.split(".");
  if (parts.length <= 1) return digitsAndDot;
  return parts[0] + "." + parts.slice(1).join("");
}
